









































































































import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import DateComponent from "@/components/common/Inputs/Date.vue";
import { http as _http } from '@/shared/https';
import TrackerContainer from './TrackerContainer.vue';
import moment from 'moment';
import { Tracker } from "@/entities";

const namespace: string = "tracker";

@Component({
  components: {
      VJsonschemaForm,
      TrackerContainer,
      DateComponent,
      DialogComponent: () => import("@/components/common/Dialog/DialogComponent.vue"),
      StoryForm: () => import("./StoryEditor/StoryForm.vue")
  }
})
export default class StoryEditorForm extends Vue {
    @State(namespace) tracker!: Tracker;
    @Prop() data!: any;
    @Prop() template!: any;
    @Prop() steps!: any;
    @Prop() selectedKey!: any;
    @Prop() editable!: boolean;
    @Prop() isDirty!: boolean;
    @Action("showLoading", {namespace:"application"} ) showLoading: any;
    @Action("hideLoading", {namespace:"application"} ) hideLoading: any;
    @Action("showNotification", { namespace: 'application' }) notify: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number;
    
    formValid: boolean = false;
    search: string = "";
    showForm: boolean = false;
    editActions = [{ event: "add", text: "Add" }, { event: "close", text: "Close" }];
    newReport: any;
    

    get options() {
        return {
        "user": this._userid,
        "username": this._username
        }
    }

    get availableSteps() {
        return this.steps.filter(x => !this.data.stories.map(x => x.StepId).includes(x.step_id));
    }

    get subSchema() {
        return this.template.properties[this.selectedKey];
    }

    getStorieName(item)
    {
     if(this.tracker.MappedStories && this.tracker.MappedStories.includes(item.StepId))
     {
        var name=`Story-${((this.tracker.MappedStories.indexOf(item.StepId)) + 1)}`;
     }
     return name;
    }

    /** set is-dirty flag  */
    setDirtyFlag() {
        this.isDirty = true;
    }

    submitted() {
        this.isDirty = false;
    }

    /** open add new dialog */
    addData() {
        this.newReport = {};
        this.showForm = true;
    }

    /** Add new report */
    addReport() {

        if(this.validateStartDate(this.newReport.StartDate, this.newReport.EndDate)) {
            this.notify({
                text: this.validateStartDate(this.newReport.StartDate, this.newReport.EndDate),
                isHtml: true,
                color: "error"
            });
        } else if(this.validateEndDate(this.newReport.StartDate, this.newReport.EndDate)) {
            this.notify({
                text: this.validateEndDate(this.newReport.StartDate, this.newReport.EndDate),
                isHtml: true,
                color: "error"
            });
        } else {
            this.newReport.ReportStatus = 'Not Started';
            this.data.stories.push(this.newReport);
            this.$emit('change');
            this.showForm = false;
        }
        // const activeReport = this.data.stories.find(x => x.ReportStatus === "In Progress");
        // if(activeReport) {
        //     if(moment(activeReport.StartDate) > moment(this.newReport.StartDate)) {
        //         this.notify({
        //             text: 'Start date must be greater than the Start date of the current period',
        //             isHtml: true,
        //             color: "error"
        //         })
        //     } else if (moment(activeReport.EndDate) > moment(this.newReport.EndDate)) {
        //         this.notify({
        //             text: 'End date must be greater than the End date of the current period',
        //             isHtml: true,
        //             color: "error"
        //         })
        //     } else if(moment(this.newReport.StartDate) > moment(this.newReport.EndDate)){
        //         this.notify({
        //             text: 'Start date must be less than the End date',
        //             isHtml: true,
        //             color: "error"
        //         })
        //     } else {
                
        //     }
        // }
        // console.log(this.newReport);
    }

    // update the start date on change
    updateStartDate(item: any, val ) {
        if(this.validateStartDate(val, item.EndDate)) {
            this.notify(
                {
                    text: this.validateStartDate(val, item.EndDate),
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            item.StartDate= val; 
            this.$emit('change');
        }
        // if(item.EndDate && moment(item.EndDate) < moment(val)) {
        //     this.notify(
        //         {
        //             text: 'Start date must be less than the End date',
        //             isHtml: true,
        //             color: "error"
        //         }
        //     );
        // } else {
        //     item.StartDate= val; 
        //     this.$emit('change');
        // }        
    }

    removeRow(item: any) {
        const index = this.data.stories.findIndex(x => x.StepId == item.StepId);
        this.data.stories.splice(index,1);
        this.$emit('change');
    }

    // update the end date on change
    updateEndDate(item: any, val ) {
        if(this.validateEndDate(item.StartDate, val, item.ReportStatus)) {
            this.notify(
                {
                    text: this.validateEndDate(item.StartDate, val, item.ReportStatus),
                    isHtml: true,
                    color: "error"
                }
            );
        } else {
            item.EndDate= val; 
            this.$emit('change');
        }        
    }


    /** set the menu on menu change */
    setMenu(key) {
        this.$emit('menuChanged', key);
    }

    /** validate the start date */
    validateStartDate(startdate, enddate) {

        const activeReport = this.data.stories.find(x => x.ReportStatus === "In Progress");

        if(moment(startdate) > moment(enddate)){
            return 'Start date must be less than the End date';
        }

        if(activeReport) {            
            if(moment(activeReport.StartDate) > moment(startdate)) {
                return 'Start date must be greater than the Start date of the current period';
            }             
        }

        return '';
    }

    /** validate the end date */
    validateEndDate(startdate, enddate, status = "") {

        const activeReport = this.data.stories.find(x => x.ReportStatus === "In Progress");

        if(moment(startdate) > moment(enddate)){
            return 'Start date must be less than the End date';
        }

        if(activeReport && status !== "In Progress") {
            if(moment(activeReport.EndDate) > moment(enddate)) {
                return 'End date must be greater than the End date of the period which is in progress';
            }
        }

        return '';
    }


}

